import { render, staticRenderFns } from "./lawsuitPhaseForm.vue?vue&type=template&id=710d5dfc&scoped=true"
import script from "./lawsuitPhaseForm.vue?vue&type=script&lang=js"
export * from "./lawsuitPhaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d5dfc",
  null
  
)

export default component.exports